interface getPaymentInfoProps {
  data: any
  payerMobile: any
  subType: any
  eligibilityResponseID: any
  selectedEMIData: any
}
export const getPaymentObject = ({
  data,
  payerMobile,
  subType,
  eligibilityResponseID,
  selectedEMIData,
}: getPaymentInfoProps) => {
  return {
    mobileNo: payerMobile,
    metadata: JSON.stringify(data),
    subType: subType,
    eligibilityResponseID: eligibilityResponseID,
    routingId: selectedEMIData.routingId,
    type: 'JioFinanceHub',
    paymentType: 'JioFinanceHub',
    emi: {
      bank: selectedEMIData.bankId,
      tenure: selectedEMIData.tenure,
      scheme: selectedEMIData.scheme,
      interestRate: selectedEMIData.interestRate,
      discount: selectedEMIData.discount ?? '0',
      cashBack: selectedEMIData.cashBack ?? '0',
      metadata: JSON.stringify(selectedEMIData.metadata),
      processingEntityId: selectedEMIData.processingEntityId,
      processingEntitySchemeId: selectedEMIData.processingEntitySchemeId,
      processingMethod: selectedEMIData.processingMethod,
      schemeSubType: selectedEMIData.schemeSubType,
      schemeType: selectedEMIData.schemeType,
    },
  }
}
